import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import genGetRequest from '../../../../helper/genGetRequest'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'

const apiGetListTimeServicesAtOfficeByTicket = `${host}admin/exportJSON/averageOfficeTimeByTicket`
const apiExportListTimeServicesAtOfficeByTicket = `${host}admin/export/averageOfficeTimeByTicket`

export const getListTimeServicesAtOfficeByTicket = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
}) => async (dispatch) => {
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListTimeServicesAtOfficeByTicket,
            dataRequest
        )
        const { data } = res
        dispatch({
            type: types.GET_LIST_TIME_SERVICES_AT_OFFICE_BY_TICKET,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    ReportCodeName,
                    BranchName,
                },
                listData: data.Data || [],
            },
        })
    } catch (err) {
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_TIME_SERVICES_AT_OFFICE_BY_TICKET_ERROR,
            () => false
        )
    }
}

export const exportListTimeServicesAtOfficeByTicket = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
    BranchCodes,
}) => async (dispatch) => {
    if (!BranchCodes) return

    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListTimeServicesAtOfficeByTicket,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${BranchCodes.join('-')}`
            )
        }
    } catch (err) {
        console.log(err)
    }
}
